import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IMembershipVehicleList } from "../../../Pages/MembershipVehicle/IMembershipVehicle";

export const AddMembershipVehicleSlicer = createSlice({
  name: "AddMembershipVehicle",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IMembershipVehicleList>,
  reducers: {
    addMembershipVehicle: (state, _) => {
      state.isLoading = true;
    },
    successAddMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddMembershipVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddMembershipVehicleState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addMembershipVehicle,
  failureAddMembershipVehicle,
  successAddMembershipVehicle,
  clearAddMembershipVehicleState,
} = AddMembershipVehicleSlicer.actions;

export default AddMembershipVehicleSlicer.reducer;
